var _g, _path, _path2, _linearGradient, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3FB6D3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 64.2L76.3 0h39.4L32.1 83.6zM76.3 128h39.4L81.6 93.9l34.1-34.8H76.3L42.2 93.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27AACD",
    d: "M81.6 93.9l-20-20-19.4 19.6 19.4 19.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#19599A",
    d: "M115.7 128L81.6 93.9l-20 19.2L76.3 128z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "flutter-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 59.365,
    y1: 116.36,
    x2: 86.825,
    y2: 99.399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b4e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1a5497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195a9b"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flutter-original-a)",
    d: "M61.6 113.1l30.8-8.4-10.8-10.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/Flutter.5be541dd37acf42d0d53cc72fd48362c.svg";
export { ForwardRef as ReactComponent };